import importOrgExcel from './import/importOrgExcel';
import importDudaoExcel from './import/importDudaoExcel';
import importStuExcel from './import/importStuExcel';
import importOutStandExcel from './import/importOutStandExcel';
import orgView from './view/orgView';
import dudaoView from './view/dudaoView';
import stuView from './view/stuView';
import outStandView from './view/outStandView';
import total from './statistics/total';
import summary from './statistics/summary';
import outStandStat from './statistics/outStandStat';
import outStandTotal from './statistics/outStandTotal';
import twoBestTotal from './statistics/twoBestTotal';
import gradeTotal from './statistics/gradeTotal';

export default {
    importOrgExcel,
    importDudaoExcel,
    importStuExcel,
    importOutStandExcel,
    orgView,
    dudaoView,
    stuView,
    outStandView,
    total,
    summary,
    outStandStat,
    outStandTotal,
    twoBestTotal,
    gradeTotal
}